module.exports = __webpack_public_path__ + "images/saaremaa/routes/pointers/SVI-ROH-SVI.png";